module.exports = __webpack_public_path__ + "img/owner.ca839f32.png";